import type { ModuleDefinition } from "../types";
import "./messages.nav";
import { AUDIT_READ, BILLING_PAYMENTS, MEMBERS_PORTAL, PORTAL_REQUESTS, PORTAL_SETTINGS } from "./permissions";
import { MemberRequestsBadge } from "./RequestsBadge";

const screens = () => import("./screens");

export const portalModule: ModuleDefinition = {
  id: "portal",
  labelKey: "module.portal",
  nav: [
    { id: "portal-member-requests", labelKey: "portal.nav.memberRequests", to: "/portal/member-requests", icon: "flag", permission: PORTAL_REQUESTS, badge: MemberRequestsBadge },
    { id: "portal-access", labelKey: "portal.nav.access", to: "/portal/access", icon: "key", permission: MEMBERS_PORTAL },
    { id: "portal-settings", labelKey: "portal.nav.settings", to: "/portal/settings", icon: "sliders", permission: PORTAL_SETTINGS },
    { id: "portal-app", labelKey: "portal.nav.app", to: "/portal/app", icon: "camera", permission: PORTAL_SETTINGS },
    { id: "portal-staff-views", labelKey: "portal.nav.staffViews", to: "/portal/staff-views", icon: "log", permission: AUDIT_READ },
  ],
  routes: [
    { path: "portal", permission: MEMBERS_PORTAL, load: async () => ({ default: (await screens()).PortalIndexRedirect }) },
    { path: "portal/access", permission: MEMBERS_PORTAL, load: async () => ({ default: (await screens()).AccessPage }) },
    { path: "portal/requests", permission: MEMBERS_PORTAL, load: async () => ({ default: (await screens()).RequestsPage }) },
    { path: "portal/member-requests", permission: PORTAL_REQUESTS, load: async () => ({ default: (await screens()).MemberRequestsPage }) },
    { path: "portal/payments", permission: BILLING_PAYMENTS, load: async () => ({ default: (await screens()).PaymentsPage }) },
    { path: "portal/staff-views", permission: AUDIT_READ, load: async () => ({ default: (await screens()).StaffViewsPage }) },
    { path: "portal/settings", permission: PORTAL_SETTINGS, load: async () => ({ default: (await screens()).PortalSettingsPage }) },
    { path: "portal/app", permission: PORTAL_SETTINGS, load: async () => ({ default: (await screens()).MemberAppPage }) },
  ],
};
